import { NgModule } from "@angular/core";
import { MathMlDirective } from "./math-ml.directive";
import { MathMlService } from "./math-ml.service";

@NgModule({
  declarations: [MathMlDirective],
  exports: [MathMlDirective],
  providers: [MathMlService]
})
export class MathMlModule {}
